import api from './client';

export const uploadMedia = (file) => {
  const formData = new FormData();
  formData.append('file', file);
  return api.post('/api/admin/media/upload', formData).then(res => res.data);
};

export const deleteMedia = (id) =>
  api.delete(`/api/admin/media/${id}`).then(res => res.data);
